export type PulseCookie = [
    string, // deviceId - 0
    string, // userId - 1
    string, // isTest - 2
    string, // experiments - 3
    string, // debugExperiments - 4
    string, // referrer - 5
    string, // internalReferrer - 6
    string, // utm_campaign - 7
    string, // utm_source - 8
    string, // utm_medium - 9
    string, // clickId - 10
    string, // clickIdSrc - 11
    string, // tierId - 12
    string, // deviceLastTierId - 13
    string, // userRole - 14
    string, // attributes - 15
];

export enum PulseCookieRecordPosition {
    DEVICE_ID = 0,
    USER_ID = 1,
    IS_TEST = 2,
    EXPERIMENTS = 3,
    DEBUG_EXPERIMENTS = 4,
    REFERRER = 5,
    INTERNAL_REFERRER = 6,
    UTM_CAMPAIGN = 7,
    UTM_SOURCE = 8,
    UTM_MEDIUM = 9,
    CLICK_ID = 10,
    CLICK_ID_SRC = 11,
    TIER_ID = 12,
    DEVICE_LAST_TIER_ID = 13,
    USER_ROLE = 14,
    ATTRIBUTES = 15,
}
